import styled, { css } from 'styled-components';
import { breakpoint } from 'styles/globals';
import { getIcon } from 'styles/icons';
import { getColor, Theme } from 'styles/theme';
import Button from 'components/Globals/Base/Button';

export const VisibleContributorsWrapper = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;

  @media (${breakpoint.mdMin}) {
    max-width: calc(100% - 103px);
  }
`;

export const SeeMoreAuthorsWrapper = styled.div`
  display: flex;
  position: relative;
`;

export const MoreAuthorsDropdown = styled.div<{ theme: Theme }>`
  position: absolute;
  top: 140%;
  left: 0;
  width: 240px;
  background: ${getColor('backgroundPrimary')};
  padding: 8px 8px 16px 16px;
  box-shadow: 2px 2px 4px 0px ${getColor('borderSecondary')};
  border-top: 4px solid ${getColor('borderAccentPrimary')};
  display: flex;
  flex-direction: column;
  z-index: 11;

  @media (${breakpoint.mdMin}) {
    top: 32px;
    right: 0;
    left: unset;
  }
`;

export const MoreContributorsWrapper = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 16px;
`;

export const CloseDropdown = styled.div<{ theme: Theme }>`
  align-self: end;
  cursor: pointer;
  height: 21px;
  width: 16px;
  ${getIcon('svg-states')};

  &::before {
    ${getIcon('close-icon', { height: 15, width: 11 })};
    margin: auto;
  };
`;

export const CompactBylineWrapper = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;  
  gap: 16px;
`;

export const SeeMoreButton = styled(Button)<{ theme: Theme }>`
  font-size: 0.875rem;
  align-self: flex-start;  

  &:hover, &:active, &:focus {
    text-decoration: none;
    color: ${getColor('textAccentPrimary')};
  }
  &::after {
    transition: all 0.3s ease;
  }
`;

const animation = css`
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

export const CollapsedView = styled.div<{ theme: Theme; $isVisible: boolean }>`
  display: flex;
  gap: 8px;
  .contributors-images {
    display: flex;
    :first-child {
      z-index: 5;
    }  
    :nth-child(2) {
      margin-left: -22px;
    }
  }
  ${animation};
  animation: fadeIn 0.3s;

  ${({ $isVisible }) => !$isVisible && { display: 'none' }}
`;

export const ExpandedView = styled.div<{ theme: Theme; $isVisible: boolean }>`
  display: flex;
  flex-direction: column;  
  gap: 16px;
  animation: fadeIn 0.3s;
  ${({ $isVisible }) => !$isVisible && { display: 'none' }}
`;
